import { render, staticRenderFns } from "./GroupsByUser.vue?vue&type=template&id=7c8f9a27&scoped=true"
import script from "./GroupsByUser.vue?vue&type=script&lang=js"
export * from "./GroupsByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f9a27",
  null
  
)

export default component.exports